import { useEffect } from 'react';
import { useState } from 'react';
import business from '../../services/business';
import Loading from '../Loading';
import Modal from '../Modal';

export default function ModalProcessosOperadora({ hideModal, show, etapaIds = "", tipo = "", listaProcessos = [] }) {

    const [processos, setProcessos] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        (async (loading = true) => {
            setLoading(loading);

            let processosBuscados = [];

            if (etapaIds !== "") {
                processosBuscados = await business.getDesempenhoOperacionalProcessos(etapaIds, tipo);
            } else {
                processosBuscados = listaProcessos;
            }

            setProcessos(processosBuscados)
            setLoading(false);
        })();
    }, [etapaIds, tipo, listaProcessos]);

    return (
        <Modal show={show} handleClose={hideModal} style={{ maxWidth: '600px', maxHeight: '600px' }} modalClass="modal-cad-usuario">
            <div className="flex">
                <div className="form w-100">
                    <h1 className="title mb-25">Processos</h1>
                    {loading ? (<Loading />) : (<div>
                        {(!processos ? 'Não há processos nessa etapa.' :
                            <div className="grid col-12 fb-16 p-10">
                                <div className="span-4">ID</div>
                                <div className="span-4">Assistente</div>
                                <div className="span-4">Enfermeira</div>
                            </div>)}
                        {(processos || []).map((processo, i) => {
                            return <div key={i}>
                                <a href={`/${processo.slug}/${processo.id}`} target='_blank' rel='noreferrer'>
                                    <div className="grid col-12 hover-highlight pointer" style={{ borderBottom: '1px solid gray', padding: '10px' }}>
                                        <div className="span-4">{processo.id_protocolo}</div>
                                        <div className="span-4">{processo.assistente || '-'}</div>
                                        <div className="span-4">{processo.enfermeira || '-'}</div>
                                    </div>
                                </a>
                            </div>
                        })}
                    </div>)}
                </div>
            </div>
        </Modal>
    );
}
